import React, { useState, useEffect } from 'react';
import '../App.css';
import { Link } from 'react-router-dom';
import { Oval as Loader } from 'react-loader-spinner';
import { ToastContainer } from 'react-toastify';
import Api from './admin/cmp/api/api';

const Affiliates = () => {
  const [models, setModels] = useState([]);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoader(true);
    Api.getAffiliates(
      (response) => {
        setLoader(false);
        setModels(response);
      },
      (error) => {
        setLoader(false);
      }
    );
  };

  return (
    <main style={{ width: "min(1100px, 94%)", margin: "28px auto", minHeight: "60vh" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
        <h1 style={{ margin: 0 }}>Recommended Products</h1>
        <div style={{ color: "#6b7280" }}>
          <Link to="/">Home</Link> / <strong>Recommended Products</strong>
        </div>
      </div>

      {loader ? (
        <div style={{ padding: 40, display: 'flex', justifyContent: 'center' }}>
          <Loader type="ThreeDots" color="#02af90" height={50} width={50} visible={true} />
        </div>
      ) : models.length === 0 ? (
        <div style={{ padding: 40 }}>No recommended products found.</div>
      ) : (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 20, marginTop: 20 }}>
          {models.map((item, index) => {
            return (
              <div key={index} style={{ width: '100%', maxWidth: 340, backgroundColor: 'white', borderRadius: 12, overflow: 'hidden', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', display: 'flex', flexDirection: 'column' }}>
                <div style={{ width: '100%', height: 200, backgroundColor: '#f9f9f9', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  {item.images && item.images.length > 0 ? (
                    <img
                      src={item.images[0]}
                      alt={item.title}
                      style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                    />
                  ) : (
                    <div style={{ color: 'gray' }}>No Image</div>
                  )}
                </div>

                <div style={{ padding: 20, display: 'flex', flexDirection: 'column', flex: 1 }}>
                  <div style={{ fontSize: 18, fontWeight: 'bold', marginBottom: 8 }}>{item.title}</div>
                  <div style={{ fontSize: 20, color: '#e53935', fontWeight: 'bold', marginBottom: 12 }}>
                    ${item.price}
                  </div>
                  <div style={{ fontSize: 14, color: '#555', marginBottom: 15, flex: 1 }}>
                    {item.details}
                  </div>
                  
                  <a
                    href={item.amazonLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: 'block',
                      textAlign: 'center',
                      backgroundColor: '#FF9900',
                      color: 'black',
                      textDecoration: 'none',
                      padding: '12px',
                      borderRadius: '8px',
                      fontWeight: 'bold',
                      fontSize: 16,
                      marginTop: 'auto',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                    }}>
                    Buy on Amazon
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      )}
      <ToastContainer />
    </main>
  );
};

export default Affiliates;
